<template>
  <div id="app">
    <!--<transition name="fade"-->
                <!--mode="out-in">-->
      <router-view v-if="isRouterAlive"></router-view>
    <!--</transition>-->
  </div>

</template>

<style scoped>
  body{
    margin: 0;
  }
</style>

<script>

  export default{

    /**
     * 监控路由的跳转
     * */
    provide(){
      return {
        reload:this.reload
      }
    },

    data:function(){
      return {
        isRouterAlive:true
      }
    },
    watch:{
      '$route':function(newValue,oldValue){

      }
    },

    created:function(){
      this.windowOnLoad();

    },
    methods:{
      goBack:function(){
        this.$router.go(-1);
//
      },
      windowOnLoad:function(){
        if(!localStorage.session){
          this.$store.dispatch('setLoginState',{flag:false})
        }

      },
      reload(){
        this.isRouterAlive=false
        this.$nextTick(item=>{
          this.isRouterAlive=true
        })
      }
    },
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white!important;
}
.el-input--suffix .el-input__inner{
  text-indent: .5em;
}
.el-select{
    width: 350px;
  }
  .el-input{
    font-size: 16px;
    font-family: "Helvetica","Droidsansfallback","Heiti SC";
  }
input,select{
  border: none;
}
::-webkit-input-placeholder {
     color:rgba(204,204,204,1);
 }
:-moz-placeholder {/* Firefox 18- */
     color:rgba(204,204,204,1);
 }
::-moz-placeholder{/* Firefox 19+ */
     color:rgba(204,204,204,1);
 }
:-ms-input-placeholder {
     color:rgba(204,204,204,1);
}
 .yd-tab-nav-item{
  font-size: 17px!important;
  line-height: 17px!important;
  padding: 16px 0!important;
  color: #666666;
}
.yd-tab-nav:after{
  border: none!important;
}
.yd-tab-nav-item:not(:last-child):after{
  border: none!important;
}
.yd-tab-nav{
  color: #D61819!important;

}
.yd-tab-nav-item{
   background:rgba(247,247,249,1)!important;
}
.slider-pagination-bullets{
    bottom: 100px!important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue